var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.733,
    height: 51.237,
    viewBox: "0 0 47.733 51.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(-35 -479.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M7.173,25.219H2V12.933A12.922,12.922,0,0,1,14.933,0h9.1L21.045,4.585h-2.91C8.368,4.175,6.814,6.524,7.173,17.518v7.7Z",
    transform: "translate(33 505.535)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M11.824,23.648A11.827,11.827,0,0,1,7.222.929a11.827,11.827,0,0,1,9.2,21.789A11.75,11.75,0,0,1,11.824,23.648Zm0-18.393a6.569,6.569,0,1,0,6.569,6.569A6.576,6.576,0,0,0,11.824,5.255Z",
    transform: "translate(43.868 479.516)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(51.313 504.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M15.825,3.349c.212-.239.411-.5.648-.726a8.446,8.446,0,0,1,9.046-2.1,8.227,8.227,0,0,1,5.828,7.205,8.67,8.67,0,0,1-2.559,7.331c-1.634,1.684-3.365,3.281-5.127,4.834-2.222,1.959-4.514,3.839-6.781,5.745a1.513,1.513,0,0,1-2.335,0c-3.771-3.29-7.551-6.57-11.281-9.907a9.519,9.519,0,0,1-3.169-5.8A8.727,8.727,0,0,1,14.979,2.655q.3.3.612.6a1.089,1.089,0,0,0,.234.093Zm-.058,18.338c1.734-1.48,3.477-2.919,5.164-4.422,1.514-1.348,3.01-2.724,4.431-4.168a5.237,5.237,0,0,0,1.5-4.8,4.843,4.843,0,0,0-3.451-3.921A5.007,5.007,0,0,0,18.252,5.5c-.531.472-1.012,1-1.52,1.5A1.288,1.288,0,0,1,14.684,7c-.5-.486-.974-.99-1.478-1.467a5.179,5.179,0,0,0-5.8-.94A5.034,5.034,0,0,0,4.476,9.612a5.629,5.629,0,0,0,1.964,3.91c3.019,2.709,6.077,5.376,9.119,8.058a1.359,1.359,0,0,0,.207.107Z",
    transform: "translate(0.001 -0.001)",
    fill: "#ee7404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileicon);
export default __webpack_public_path__ + "static/media/tileicon.b4690cd9ae719c809a6b0dae4c96d710.svg";
export { ForwardRef as ReactComponent };